import { render } from "./HomeWaitingTryagain.vue?vue&type=template&id=32ae66d0"
import script from "./HomeWaitingTryagain.vue?vue&type=script&lang=js"
export * from "./HomeWaitingTryagain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__